export const UPDATE_USER_SESSION = 'UPDATE_USER_SESSION'
export const CLEAR_USER_SESSION = 'CLEAR_USER_SESSION'

export const updateUserSession = (updateHash) => ({
  type: UPDATE_USER_SESSION,
  updateHash
})

export const clearUserSession = () => ({ type: CLEAR_USER_SESSION })
